var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "GRC"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('editedjson.grcComponent')))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveGRC('saveGRCForm')
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.table.columns.dr')) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num|min:5'),
      expression: "'required|alpha_num|min:5'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('saveGRCForm.DRNo')
    },
    attrs: {
      "data-vv-scope": "saveGRCForm",
      "type": "text",
      "placeholder": _vm.$t('removeHold.drNoPlaceHolder'),
      "name": "DRNo",
      "id": "DRNo",
      "data-vv-as": "DR number",
      "disabled": true
    },
    on: {
      "keyup": _vm.showSearchDR
    },
    model: {
      value: (_vm.addGRC.DRNo),
      callback: function($$v) {
        _vm.addGRC.DRNo = $$v
      },
      expression: "addGRC.DRNo"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('saveGRCForm.DRNo')),
      expression: "errors.has('saveGRCForm.DRNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('saveGRCForm.DRNo')))]), _vm._v(" "), (_vm.DRerrors) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.DRerrors))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [(_vm.isfound) ? _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "25px",
      "color": "green"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isnotfound) ? _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.isfound) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('boxList.productPlaceholder')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('saveGRCForm.productid')
    },
    attrs: {
      "data-vv-scope": "saveGRCForm",
      "type": "text",
      "placeholder": _vm.$t('printProductDetails.productIdPlaceHolder'),
      "name": "productid",
      "id": "productid",
      "data-vv-as": "Product ID"
    },
    on: {
      "keyup": _vm.showSearchProduct
    },
    model: {
      value: (_vm.addGRC.productid),
      callback: function($$v) {
        _vm.addGRC.productid = $$v
      },
      expression: "addGRC.productid"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('saveGRCForm.productid')),
      expression: "errors.has('saveGRCForm.productid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('saveGRCForm.productid')))]), _vm._v(" "), (_vm.IDerrors) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.IDerrors))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    domProps: {
      "innerHTML": _vm._s(_vm.productCheckIcon)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openSearchProductModal
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.searchProduct')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isfound && _vm.isfoundID),
      expression: "isfound && isfoundID"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('editedjson.Pono')) + ":")])]), _vm._v(" "), _vm._l((_vm.selectPoNoList.result), function(each) {
    return _c('div', {
      staticClass: "col-md-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.addGRC.pickPoNo),
        expression: "addGRC.pickPoNo"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": each.pono,
        "checked": _vm._q(_vm.addGRC.pickPoNo, each.pono)
      },
      on: {
        "click": _vm.resetMrp,
        "__c": function($event) {
          _vm.addGRC.pickPoNo = each.pono
        }
      }
    }), _vm._v(" " + _vm._s(each.pono) + "\n              ")])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isfound && _vm.isfoundID),
      expression: "isfound && isfoundID"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.productDescription')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.productDescription))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isfound && _vm.isfoundID),
      expression: "isfound && isfoundID"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.productImage')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    attrs: {
      "src": _vm.addGRC.productImage,
      "height": "150px"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isfound && _vm.isfoundID),
      expression: "isfound && isfoundID"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('editedjson.mrpInr')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|decimal:3'),
      expression: "'required|min_value:1|decimal:3'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('saveGRCForm.MRP')
    },
    attrs: {
      "data-vv-scope": "saveGRCForm",
      "type": "text",
      "placeholder": _vm.$t('printProductDetails.mrpPH'),
      "name": "MRP",
      "id": "MRP"
    },
    on: {
      "keyup": _vm.searchProductMRP
    },
    model: {
      value: (_vm.addGRC.MRP),
      callback: function($$v) {
        _vm.addGRC.MRP = $$v
      },
      expression: "addGRC.MRP"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('saveGRCForm.MRP')),
      expression: "errors.has('saveGRCForm.MRP')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('saveGRCForm.MRP')))]), _vm._v(" "), (_vm.MRPerrors) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.MRPerrors))]) : _vm._e(), _vm._v(" "), (_vm.MRPsuccess) ? _c('span', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.MRPsuccess))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.isfoundMRP) ? _c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "font-size": "25px",
      "color": "green"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isnotfoundMRP) ? _c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "font-size": "25px",
      "color": "red"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.isfound && _vm.isfoundID && _vm.isfoundMRP) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('editedjson.InvoiceProductQty')) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.invoicePQuantity))])]) : _vm._e(), _vm._v(" "), (_vm.isFoundTotalCheckqty && _vm.isfound && _vm.isfoundID && _vm.isfoundMRP) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('editedjson.totalCheckedQty')) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.totalCheckedQty) + " Ea.")])]) : _vm._e(), _vm._v(" "), (_vm.isfound && _vm.isfoundID && _vm.isfoundMRP) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('editedjson.currentCheckedQty')) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|min_value:1|currentCheckQty'),
      expression: "'required|numeric|min_value:1|currentCheckQty'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('saveGRCForm.checkedqty')
    },
    attrs: {
      "data-vv-scope": "saveGRCForm",
      "type": "text",
      "name": "checkedqty",
      "id": "checkedqty",
      "data-vv-as": "Checked quantity"
    },
    on: {
      "keyup": function($event) {
        _vm.validateQty('currentCheckQty')
      }
    },
    model: {
      value: (_vm.addGRC.checkedqty),
      callback: function($$v) {
        _vm.addGRC.checkedqty = $$v
      },
      expression: "addGRC.checkedqty"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('saveGRCForm.checkedqty')),
      expression: "errors.has('saveGRCForm.checkedqty')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('saveGRCForm.checkedqty')))]), _vm._v(" "), (_vm.checkQtyerrors) ? _c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.checkQtyerrors))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("Ea.")])]) : _vm._e(), _vm._v(" "), (_vm.isfound && _vm.isfoundID && _vm.isfoundMRP) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('removeHold.totalAcceptedQty')) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|totalAcceptQty'),
      expression: "'required|numeric|totalAcceptQty'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('acceptedqty')
    },
    attrs: {
      "data-vv-scope": "saveGRCForm",
      "type": "text",
      "name": "acceptedqty",
      "id": "acceptedqty",
      "data-vv-as": "Accepted quantity"
    },
    on: {
      "keyup": function($event) {
        _vm.validateQty('acceptqty')
      }
    },
    model: {
      value: (_vm.addGRC.acceptedqty),
      callback: function($$v) {
        _vm.addGRC.acceptedqty = $$v
      },
      expression: "addGRC.acceptedqty"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('saveGRCForm.acceptedqty')),
      expression: "errors.has('saveGRCForm.acceptedqty')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('saveGRCForm.acceptedqty')))]), _vm._v(" "), (_vm.acceptQtyerrors) ? _c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.acceptQtyerrors))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v("Ea.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isfound && _vm.isfoundID && _vm.isfoundMRP && _vm.isfoundReject),
      expression: "isfound && isfoundID && isfoundMRP && isfoundReject"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('removeHold.totalRejectedQty')) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('rejectedqty')
    },
    attrs: {
      "type": "text",
      "name": "rejectedqty",
      "id": "rejectedqty"
    },
    on: {
      "keyup": function($event) {
        _vm.validateQty('rejectqty')
      }
    },
    model: {
      value: (_vm.addGRC.rejectedqty),
      callback: function($$v) {
        _vm.addGRC.rejectedqty = $$v
      },
      expression: "addGRC.rejectedqty"
    }
  }), _vm._v(" "), (_vm.rejectQtyerrors) ? _c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.rejectQtyerrors))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_vm._v("Ea.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isfound && _vm.isfoundID && _vm.isfoundMRP && _vm.isfoundReject),
      expression: "isfound && isfoundID && isfoundMRP && isfoundReject"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('removeHold.totalHoldQty')) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('holdqty')
    },
    attrs: {
      "type": "text",
      "name": "holdqty",
      "id": "holdqty"
    },
    on: {
      "keyup": function($event) {
        _vm.validateQty('holdqty')
      }
    },
    model: {
      value: (_vm.addGRC.holdqty),
      callback: function($$v) {
        _vm.addGRC.holdqty = $$v
      },
      expression: "addGRC.holdqty"
    }
  }), _vm._v(" "), (_vm.holdQtyerrors) ? _c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.holdQtyerrors))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_vm._v("Ea.")])]), _vm._v(" "), (_vm.isfound && _vm.isfoundID && _vm.isfoundReject) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('shipment.rejectedReasons')) + ": ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('v-select', {
    staticClass: "style-chooser",
    attrs: {
      "disabled": !_vm.isEnblRejectReason,
      "options": _vm.rejectOptions,
      "multiple": "",
      "item-color": "success",
      "clear-on-select": false,
      "close-on-select": false,
      "preserve-search": true
    },
    model: {
      value: (_vm.rejectReason),
      callback: function($$v) {
        _vm.rejectReason = $$v
      },
      expression: "rejectReason"
    }
  }), _vm._v(" "), (_vm.rejectReasonErrors) ? _c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.rejectReasonErrors))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isfound && _vm.isfoundID && _vm.isfoundReject) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('editedjson.holdReasons')) + ": ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('multiselect', {
    attrs: {
      "disabled": !_vm.isEnblHoldReason,
      "options": _vm.holdOptions,
      "multiple": true,
      "hide-selected": true,
      "preserve-search": true,
      "clear-on-select": false
    },
    model: {
      value: (_vm.holdReason),
      callback: function($$v) {
        _vm.holdReason = $$v
      },
      expression: "holdReason"
    }
  }), _vm._v(" "), (_vm.holdReasonErrors) ? _c('label', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.holdReasonErrors))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isfound && _vm.isfoundID && _vm.isfoundMRP && _vm.isExpiry) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.openExpiryModal
    }
  }, [_vm._v("Enter Expiry Details")])]), _vm._v(" "), (_vm.expiryDtlErrors) ? _c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.expiryDtlErrors))]) : _vm._e()]), _vm._v(" "), (_vm.addGRC.shelfLife && _vm.isExpiryCol) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('srqc.shelfLife')) + ": " + _vm._s(_vm.addGRC.shelfLife))])]) : _vm._e(), _vm._v(" "), (_vm.addGRC.mfgdate && _vm.isExpiryCol) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('grcLotReport.manufactureDate')) + ": " + _vm._s(_vm.addGRC.mfgdate))])]) : _vm._e(), _vm._v(" "), (_vm.addGRC.expdate && _vm.isExpiryCol) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('printProductDetails.expiryDate')) + ": " + _vm._s(_vm.addGRC.expdate))])]) : _vm._e(), _vm._v(" "), (_vm.addGRC.lotControl && _vm.isExpiryCol) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('printProductDetails.lotControl')) + ": " + _vm._s(_vm.addGRC.lotControl))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "GRCfooter form-actions"
  }, [_c('b-button', {
    staticStyle: {
      "margin-left": "110%"
    },
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "success",
      "disabled": !_vm.isComplete
    }
  }, [_vm._v("Save")])], 1)])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.productSearchModal),
      callback: function($$v) {
        _vm.productSearchModal = $$v
      },
      expression: "productSearchModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.searchProduct($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('editedjson.SearchProductCode')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('editedjson.SearchProductCode')))]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "searchProductFlt",
      "id": "searchProductFlt",
      "placeholder": _vm.$t('removeHold.ProductIDandEAN'),
      "data-vv-as": "Product ID/EAN Code"
    },
    model: {
      value: (_vm.searchProductFlt),
      callback: function($$v) {
        _vm.searchProductFlt = $$v
      },
      expression: "searchProductFlt"
    }
  }), _vm._v(" "), (_vm.searchProductFltError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.searchProductFltError))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.searchBtn')))])], 1)])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.expiryDetailsModal),
      callback: function($$v) {
        _vm.expiryDetailsModal = $$v
      },
      expression: "expiryDetailsModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.expiryDetailsForm('expiryForm')
      }
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('editedjson.expiryDetails')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [(_vm.shelfLifeCheck) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('srqc.shelfLife')) + ": " + _vm._s(_vm.addGRC.shelfLife))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('grcLotReport.manufactureDate')) + " :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addGRC.mfgdate),
      expression: "addGRC.mfgdate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY|before:' + _vm.todayDate),
      expression: "'required|date_format:DD/MM/YYYY|before:'+todayDate"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('expiryForm.mfgdate')
    },
    attrs: {
      "data-vv-scope": "expiryForm",
      "placeholder": _vm.$t('editedjson.manufactureDateErr'),
      "name": "mfgdate",
      "data-vv-as": "Manufacture Date",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.addGRC.mfgdate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addGRC.mfgdate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('expiryForm.mfgdate')),
      expression: "errors.has('expiryForm.mfgdate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('expiryForm.mfgdate')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.shelfLifeCheck),
      expression: "!shelfLifeCheck"
    }],
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.expiryDate')) + " :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addGRC.expdate),
      expression: "addGRC.expdate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.shelfLifeCheck ? '' : 'required|date_format:DD/MM/YYYY|after:mfgdate'),
      expression: "shelfLifeCheck ? '' : 'required|date_format:DD/MM/YYYY|after:mfgdate'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('expiryForm.expdate')
    },
    attrs: {
      "data-vv-scope": "expiryForm",
      "placeholder": _vm.$t('editedjson.expiryDateError'),
      "name": "expdate",
      "data-vv-as": "Expiry Date",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.addGRC.expdate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addGRC.expdate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('expiryForm.expdate')),
      expression: "errors.has('expiryForm.expdate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('expiryForm.expdate')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.shelfLifeCheck && _vm.lotControlCheck),
      expression: "!shelfLifeCheck && lotControlCheck"
    }],
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.lotControl')) + " :")]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.shelfLifeCheck ? '' : 'required|numeric|min_value:1'),
      expression: "shelfLifeCheck ? '' : 'required|numeric|min_value:1'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('expiryForm.lotControl')
    },
    attrs: {
      "data-vv-scope": "expiryForm",
      "type": "text",
      "placeholder": "Enter lot control number",
      "name": "lotControl",
      "data-vv-as": "Lot Control",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.addGRC.lotControl),
      callback: function($$v) {
        _vm.addGRC.lotControl = $$v
      },
      expression: "addGRC.lotControl"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('expiryForm.lotControl')),
      expression: "errors.has('expiryForm.lotControl')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('expiryForm.lotControl')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.done')))])], 1)])])])])], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-541655e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-541655e2","hasScoped":true}!./src/views/components/GRC/grc.component.html
// module id = 1266
// module chunks = 0